import ReducerUtilities from '../../../shared/store/reducer-utilities';
import tagModel from '../../models/tag';
import tagsCommitTypes from '../tags/commit-types';

const INITIAL_TAGS_STATE = {
  isAddingTag: false,
  isEditingTag: null,
  isLoading: [],
  list: null,
  selectedTag: null,
};

function tagsReducers(state = INITIAL_TAGS_STATE, action) {
  if (!action || !action.type) {
    return state;
  }

  switch (action.type) {
    case tagsCommitTypes.PUSH_TAG:
      return {
        ...state,
        list: !state.list ? [tagModel(action.tag)] : [tagModel(action.tag), ...state.list],
      };
    case tagsCommitTypes.PUSH_TAGS:
      return {
        ...state,
        list: [...action.tags.map(item => tagModel(item))],
      };
    case tagsCommitTypes.REPLACE_TAG:
      return {
        ...state,
        list: [...ReducerUtilities.replaceModelInList(tagModel(action.tag), state.list)],
      };
    case tagsCommitTypes.SET_IS_ADDING_TAG:
      return {
        ...state,
        isAddingTag: action.isAddingTag,
      };
    case tagsCommitTypes.SET_IS_EDITING_TAG:
      return {
        ...state,
        isEditingTag: action.isEditingTag,
      };
    case tagsCommitTypes.SET_SELECTED_TAG_GUID:
      return {
        ...state,
        selectedTag: action.selectedTag,
      };
    case tagsCommitTypes.SET_TAGS_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(action.isLoading, state.isLoading),
      };
    default:
      return state;
  }
}

export default tagsReducers;
